import { Col, Drawer, Form, Input, Row } from 'antd';
import moment from 'moment';
import React from 'react';
import DetailsButtons from '../../../../components/details-buttons';
import { DrawerWidth } from '../../../../config/dimensions';
import ReplaceStrings from '../../../../config/replaceStrings';
import Routes from '../../../../config/routes';
import { DrawerState, ModuleName } from '../../../../core/models/enum';
import { formItemLayout724 } from '../../../../helpers/FormLayoutHelper';
import { getNewRoute } from '../../../../helpers/RoutingHelper';
import { handleDeleteHelper } from '../../../../helpers/SubmitHelper';
import { MatchesClient } from '../../../../utils/api';
import MatchForm from '../../match-form';
import { Props } from './index';

interface State {
    drawerState: DrawerState;
    loading: boolean;
}

class MatchDetails extends React.PureComponent<Props, State> {
    public constructor(props: Props) {
        super(props);

        this.state = {
            drawerState: props.isInitialEdit ? DrawerState.Edit : DrawerState.Closed,
            loading: true,
        };
    }

    private handleDrawerMode = (drawerState: DrawerState, id?: string): void => {
        const { history } = this.props;

        this.setState({
            drawerState,
        });

        history.push(
            getNewRoute(
                Routes.ROUTE_MATCHES,
                Routes.ROUTE_MATCHES_READ,
                Routes.ROUTE_MATCHES_EDIT,
                drawerState,
                ReplaceStrings.MATCH_ID,
                id
            )
        );
    };

    private openForm = (): void => {
        const { matchFromProps } = this.props;
        this.handleDrawerMode(DrawerState.Edit, matchFromProps.id.toString());
    };

    private handleDelete = (): void => {
        const { history } = this.props;

        history.push(Routes.ROUTE_MATCHES);
    };

    public render(): React.ReactElement {
        const { drawerState } = this.state;
        const { userProfile, matchFromProps, refreshAfterSave } = this.props;

        return (
            <div>
                <DetailsButtons
                    userProfile={userProfile}
                    onDeleteAction={(): Promise<void> =>
                        handleDeleteHelper(
                            new MatchesClient(),
                            'Match successfully deleted.',
                            this.handleDelete,
                            matchFromProps.id
                        )
                    }
                    onEditAction={this.openForm}
                    customMessage="Are you sure you want to delete this match?"
                    moduleName={ModuleName.Matches}
                    entityId={matchFromProps.id}
                />
                <Row className="details-height">
                    <Col span={12}>
                        <Form {...formItemLayout724}>
                            <Form.Item label="Home team">
                                <Input readOnly value={matchFromProps.homeTeamDisplayName} />
                            </Form.Item>
                            <Form.Item label="Away team">
                                <Input readOnly value={matchFromProps.awayTeamDisplayName} />
                            </Form.Item>
                            <Form.Item label="Competition">
                                <Input readOnly value={matchFromProps.competitionDisplayName} />
                            </Form.Item>

                            <Form.Item label="Competition stage">
                                <Input readOnly value={matchFromProps.competitionStage} />
                            </Form.Item>
                            <Form.Item label="Venue">
                                <Input readOnly value={matchFromProps.venue} />
                            </Form.Item>
                            <Form.Item label="Round">
                                <Input readOnly value={matchFromProps.round} />
                            </Form.Item>
                            <Form.Item label="Game No.">
                                <Input readOnly value={matchFromProps.number} />
                            </Form.Item>
                            <Form.Item label="Country">
                                <Input readOnly value={matchFromProps.country} />
                            </Form.Item>
                            <Form.Item label="City">
                                <Input readOnly value={matchFromProps.city} />
                            </Form.Item>
                            <Form.Item label="Start">
                                <Input
                                    readOnly
                                    value={
                                        matchFromProps.startDate
                                            ? moment(matchFromProps.startDate).format(
                                                  'DD.MM.YYYY. HH:mm'
                                              )
                                            : ''
                                    }
                                />
                            </Form.Item>
                            <Form.Item label="End">
                                <Input
                                    readOnly
                                    value={
                                        matchFromProps.endDate
                                            ? moment(matchFromProps.endDate).format(
                                                  'DD.MM.YYYY. HH:mm'
                                              )
                                            : ''
                                    }
                                />
                            </Form.Item>
                            <Form.Item label="Match segment">
                                <Input readOnly value={matchFromProps.matchSegment} />
                            </Form.Item>
                            <Form.Item label="Match segment length">
                                <Input readOnly value={matchFromProps.matchSegmentLength} />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col span={12}>
                        <Form {...formItemLayout724}>
                            <Form.Item label="Home team score">
                                <Input readOnly value={matchFromProps.homeTeamGoalsTotal} />
                            </Form.Item>
                            <Form.Item label="Away teams score">
                                <Input readOnly value={matchFromProps.awayTeamGoalsTotal} />
                            </Form.Item>
                            <Form.Item label="Status">
                                <Input readOnly value={matchFromProps.status.replace('_', ' ')} />
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
                <Drawer
                    title="Edit match"
                    visible={drawerState === DrawerState.Edit}
                    onClose={(): void =>
                        this.handleDrawerMode(DrawerState.Read, matchFromProps.id.toString())
                    }
                    width={DrawerWidth}
                    destroyOnClose
                >
                    <MatchForm
                        handleClose={this.handleDrawerMode}
                        refreshAfterSave={refreshAfterSave}
                        matchFromProps={matchFromProps}
                    />
                </Drawer>
            </div>
        );
    }
}

export default MatchDetails;
